<template>
  <div class="AddressEdit">
    <el-tabs type="border-card" :stretch="true">
      <el-tab-pane label="地址编辑" >
        <span slot="label"><p class="el-icon-arrow-left back-icon" @click="back()"></p> 地址信息 </span>
        <div class="info-background">
          <el-form class="rule-form" :model="ruleForm" :rules="rules" ref="ruleForm" label-width="80px" label-position="left" :hide-required-asterisk="true">
            <el-form-item label="联系人" prop="name">
              <el-input v-model="ruleForm.name" ></el-input>
            </el-form-item>
            <el-form-item label="联系电话" prop="phone">
              <el-input v-model="ruleForm.phone" ></el-input>
            </el-form-item>
            <el-form-item label="所在地区" prop="province">
              <el-input v-model="ruleForm.province" @focus="drawer = true" :readonly="true"></el-input>
              <el-drawer
                  title="省市区选择"
                  v-if="drawer"
                  :visible.sync="drawer"
                  :direction="direction"
                  :with-header="false"
                  :size="size">
                <mt-picker :slots="myAddressSlots" valueKey="name" :showToolbar="true" :visibleItemCount	="5" @change="addressChange">
                  <Slot>
                    <div class="address_picker_toolbar">
                      <el-row :gutter="20">
                        <el-col :span="4"><span class="address_picker_confirm" @click="drawer=false">取消</span></el-col>
                        <el-col :span="16"><div class="grid-content bg-purple">省市区选择</div></el-col>
                        <el-col :span="4"><span class="address_picker_confirm" @click="confirmAddress">确认</span></el-col>
                      </el-row>
                    </div>
                  </Slot>
                </mt-picker>
<!--                <v-distpicker type="mobile" @selected="onSelected"></v-distpicker>-->
              </el-drawer>
            </el-form-item>
            <el-form-item label="详细地址" prop="address">
              <el-input
                  type="textarea"
                  :rows="3"
                  placeholder="请具体到楼号及门牌号"
                  v-model="ruleForm.address">
              </el-input>
            </el-form-item>
            <el-form-item label="默认地址" prop="selected">
                <el-switch
                    v-model="ruleForm.selected"
                    active-color="#13ce66"
                    inactive-color="#9da7bf"
                    :active-value= 1
                    :inactive-value= 0
                    class="selected-switch">
                </el-switch>
            </el-form-item>
          </el-form>
          <el-button class="savebtn" type="primary" @click="saveAddress('ruleForm')">提交</el-button>
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
    // import levelAddress from '@/assets/leveladdress.json'
    import cityData from '@/assets/city-data.js'

    export default {
        name: "addressEdit",
        data(){
            var checkPhone = (rule, value, callback) => {
                if (!value) {
                    return callback(new Error('手机号不能为空'));
                } else {
                    const reg = /^1[3|4|5|6|7|8|9][0-9]\d{8}$/;
                    const reg2 = /0\d{2,3}-\d{7,8}/;
                    const reg3 = /^0\d{9,11}$/;
                    // console.log(reg.test(value));
                    // console.log(reg2.test(value));
                    // console.log(reg3.test(value));
                    if (reg.test(value) || reg2.test(value) || reg3.test(value)) {
                        callback();
                    } else {
                        return callback(new Error('请输入正确的电话'));
                    }
                }
            };
            return{
                ruleForm: {
                    id: '',
                    unionid: '',
                    name: '',
                    phone: '',
                    province: '',
                    address: '',
                    selected: ''
                },
                rules: {
                    name: [
                        { required: true, message: '请输入姓名', trigger: 'blur' },
                        { min: 1, max: 6, message: '长度在 1 到 6 个字符', trigger: 'blur' }
                    ],
                    phone: [
                        { required: true, message: '请输入联系电话', trigger: 'blur'},
                        { validator: checkPhone, trigger: 'blur'}
                    ],
                    province: [
                        { required: true, message: '请选择所在地区'}
                    ],
                    address: [
                        { required: true, message: '请输入详细地址', trigger: 'blur'}
                    ]
                },
                drawer: false,
                direction: 'btt',
                size: '40%',

                region:'',//三级地址
                regionInit:false,//禁止地区选择器自动初始化，picker组件会默认进行初始化，导致一进入页面就会默认选中一个初始3级地址
                //picker组件插槽
                myAddressSlots: [
                    //省
                    {
                        flex: 1,
                        values: this.getProvinceArr(), //省份数组
                        className: 'slot1',
                        textAlign: 'center'
                    },
                    //分隔符
                    {
                        divider: true,
                        content: '',
                        className: 'slot2'
                    },
                    //市
                    {
                        flex: 1,
                        values: this.getCityArr("北京"),
                        className: 'slot3',
                        textAlign: 'center'
                    },
                    {
                        divider: true,
                        content: '',
                        className: 'slot4'
                    },
                    //县
                    {
                        flex: 1,
                        values: this.getCountyArr("北京","北京"),
                        className: 'slot5',
                        textAlign: 'center'
                    }
                ]
            }
        },
        mounted:function() {
            if (this.$route.params.contact) {
                this.ruleForm = this.$route.params.contact
            }
        },
        methods:{
            back(){
                this.$router.back();
            },
            confirmAddress(){
                //取值并赋值
                this.ruleForm.province = this.region;
                console.log(this.ruleForm.province);
                this.drawer = false;
            },
            //picker组件的change事件，进行取值赋值
            addressChange(picker, values){
                if (this.regionInit){
                    this.region = values[0]["name"] + " " + values[1]["name"] + " " + values[2]["name"];
                    //给市、县赋值
                    picker.setSlotValues(1, this.getCityArr(values[0]["name"]));
                    picker.setSlotValues(2, this.getCountyArr(values[0]["name"], values[1]["name"]));
                }else {
                    this.regionInit = true;
                }
            },
            //遍历json，返回省级对象数组
            getProvinceArr() {
              let provinceArr = [];
              cityData.forEach(function (item) {
                  let obj = {};
                  obj.name = item.label;
                  provinceArr.push(obj);
              });
              return provinceArr;
            },
            //遍历json，返回市级对象数组
            getCityArr(province) {
              let cityArr = [];
              cityData.forEach(function (item) {
                  if (item.label === province) {
                      item.children.forEach(function (args) {
                          let obj = {};
                          obj.name = args.label;
                          cityArr.push(obj);
                      });
                  }
              });
              return cityArr;
            },
            //遍历json，返回县级对象数组
            getCountyArr(province,city){
              let countyArr = [];
              cityData.forEach(function(item){
                  if (item.label === province){
                      item.children.forEach(function (args) {
                          if (args.label === city){
                              args.children.forEach(function (param) {
                                  let obj = {};
                                  obj.name=param.label;
                                  countyArr.push(obj);
                              })
                          }
                      });
                  }
              });
              return countyArr;
            },
            saveAddress(formName){
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        this.ruleForm.unionid = window.localStorage.getItem("fastunionid");
                        // 根据有无id判断新增和修改
                        if(this.ruleForm.id==''){
                            // 新增
                            this.$axios.post(this.$baseURL + `/contact`,this.$qs.stringify(this.ruleForm))
                                .then(()=> {
                                    console.log("新增成功");
                                    this.$router.push({
                                        name:"AddressInfo",
                                        params: {
                                            refresh: this.ruleForm
                                        }
                                    })
                                })
                                .catch(error=> {
                                    console.log(error);
                                });
                        }else{
                            // 修改
                            this.$axios.put(this.$baseURL + `/contact`,this.$qs.stringify(this.ruleForm))
                                .then(()=> {
                                    console.log("修改成功");
                                    this.$router.push({
                                        name:"AddressInfo",
                                        params: {
                                            refresh: this.ruleForm
                                        }
                                    })
                                })
                                .catch(error=> {
                                    console.log(error);
                                });
                        }
                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });
            },
            onSelected(data) {
                this.ruleForm.province = data.province.value + ' ' + data.city.value + ' ' + data.area.value
            }
        }
    }
</script>

<style scoped>
  .AddressEdit {
    height: 100%;
  }
  .AddressEdit > .el-tabs{
    height: 100%;
  }
  .info-add p {
    display:inline-block;
    font-size: 15px;
    margin: 0px 15px 6px 15px;
    color: #333333;
  }
  .rule-form {
    padding: 12px;
    font-size: 12px;
  }
  .savebtn {
    margin-bottom: 20px;
  }
  .selected-switch {
    float: right;
    top: 10px;
  }
</style>

<style >
  .el-drawer.btt {
    overflow: scroll
  }
</style>
